import IconButton from '@mui/material/IconButton';
import SearchIcon from '@mui/icons-material/Search';
import {useState} from 'react';
import {debounce} from 'lodash';
import {OutlinedInput, OutlinedInputProps, Stack} from '@mui/material';
import CancelIcon from '@mui/icons-material/Cancel';

interface SearchInputProps extends OutlinedInputProps {
  onSearch: (value: string) => void;
  placeholder?: string;
}

export default function SearchInput({onSearch, placeholder, ...props}: SearchInputProps) {
  const [val, setVal] = useState('');
  const debouncedSearch = debounce(onSearch, 200);

  return (
    <OutlinedInput
      {...props}
      sx={{paddingRight: 0, flex: 1}}
      size="small"
      placeholder={placeholder || 'Search'}
      value={val}
      onChange={e => setVal(e.target.value)}
      endAdornment={
        <Stack direction="row" alignItems="center" width={70} justifyContent={'flex-end'}>
          {val && (
            <CancelIcon
              sx={{
                '& :hover': {
                  cursor: 'pointer',
                },
              }}
              onClick={() => {
                setVal('');
                debouncedSearch('');
              }}
            />
          )}
          <IconButton type="button" aria-label="search" onClick={() => debouncedSearch(val)}>
            <SearchIcon />
          </IconButton>
        </Stack>
      }
    />
  );
}
